import { borderRadius, color, snap } from '@m/alchemy-ui/theme';
import styled from 'styled-components';

import { Dialog } from '@m/alchemy-ui/Dialog';
import { DialogBody } from '@m/alchemy-ui/DialogBody';
import { DialogHeader } from '@m/alchemy-ui/DialogHeader';
import { LoadingIndicator } from '@m/alchemy-ui/LoadingIndicator';

import { FormattedMessage } from 'react-intl';

const DialogContent = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  > * {
    padding-bottom: 0;
  }
`;

const StyledLoadingIndicator = styled(LoadingIndicator)`
  height: ${snap(100)};
  background: ${color('container')};
  border-radius: ${borderRadius('extraLarge')};
`;

export const ProfilePreview = ({
  isDialogOpen,
  closeDialog,
  isDialogLoading,
  dialogData
}: {
  readonly isDialogOpen: boolean;
  readonly closeDialog: () => void;
  readonly isDialogLoading: boolean;
  readonly dialogData: string;
}) => (
  <Dialog isCentered hasCloseIcon isOpen={isDialogOpen} onClose={closeDialog} size="large">
    {isDialogLoading ? (
      <StyledLoadingIndicator />
    ) : (
      <DialogContent>
        <DialogHeader>
          <FormattedMessage id="profile" defaultMessage="Profile" />
        </DialogHeader>
        <DialogBody dangerouslySetInnerHTML={{ __html: dialogData }} />
      </DialogContent>
    )}
  </Dialog>
);
